module.exports = __webpack_public_path__ + "img/jz-pic1.dfc9e09a.png";